import axios from 'axios'
import config from './config'
import Cookies from 'js-cookie'
import jwt_decode from 'jwt-decode'
import usersService from '../services/usersService'

export default {
  async login(method, uri, data) {
    const url = config.serverURI + uri;
    const headers = config.headers;

    return await axios({
      method: method,
      url: url,
      data: data,
      headers: headers
    })
  },
  async logout(msg) {
    // try {
    const resp = await usersService.logout();
    // const clearCacheData = () => {
    //   caches.keys().then((names) => {
    //     names.forEach((name) => {
    //       caches.delete(name)
    //     })
    //   })
    // }
    // clearCacheData()

    setTimeout(() => {
      if (msg) localStorage.setItem('msg', msg);
      window.location = '/login';
    }, 500)
    // } catch (err) {
    //   console.log(err)
    // }
    Cookies.remove("userToken");
    Cookies.remove("userLogged");
    Cookies.remove("userID");
    Cookies.remove("userName");
    Cookies.remove("userEmail");
    Cookies.remove("spaceTableData");
    Cookies.remove("backupsTableData");
    Cookies.remove("totalGB");
    Cookies.remove("stationNumber");
    Cookies.remove("stationName");
    Cookies.remove("stationOption");
    Cookies.remove("decodeToken");
    Cookies.remove("userRole");
    localStorage.removeItem("station");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("cent");
    localStorage.removeItem("seg");
    localStorage.removeItem("attributes");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("role");
    localStorage.removeItem("user");
    localStorage.removeItem("stationId");
    localStorage.removeItem("stationName");
    localStorage.removeItem("stationsJSON");
  },
  setUserLogged(userLogged) {
    Cookies.set("userLogged", userLogged);
  },
  setUserToken(userToken) {
    this.setDecodeToken(userToken);
    Cookies.set('userToken', `Bearer ${userToken.token}`);
  },
  async setDecodeToken(data) {
    const decodeToken = jwt_decode(data.token);
    Cookies.set("decodeToken", JSON.stringify(decodeToken));
    localStorage.removeItem('msg');
  },
  setSpaceTable(data) {
    Cookies.set("spaceTableData", JSON.stringify(data));
  },
  setBackupsTable(data) {
    Cookies.set("backupsTableData", JSON.stringify(data));
  },
  setTotalGB(val) {
    Cookies.set("totalGB", val);
  },
  setStationNumber(station) {
    Cookies.set("stationNumber", station);
  },
  setStationName(station) {
    Cookies.set("stationName", station.name);
    Cookies.set("stationID", station.id);
    Cookies.set("stationOption", JSON.stringify({ id: station.id }));
  },
  setRefreshToken(token) {
    Cookies.set("refreshToken", token);
  },
  getUserToken() {
    return Cookies.get("userToken");
  },
  getUserLogged() {
    return Cookies.get("userLogged");
  },
  getUserID() {
    return Cookies.get("userID");
  },
  getName() {
    return Cookies.get("userName");
  },
  getEmail() {
    return Cookies.get("userEmail");
  },
  getSpaceTable() {
    return Cookies.get("spaceTableData");
  },
  getBackupsTable() {
    return Cookies.get("backupsTableData");
  },
  getTotalGB() {
    return Cookies.get("totalGB");
  },
  getStationNumber() {
    return Cookies.get("stationNumber");
  },
  getStationName() {
    return Cookies.get("stationName");
  },
  getStationOption() {
    return Cookies.get("stationOption");
  },
  getStationID() {
    return Cookies.get("stationID");
  },
  getRefreshToken() {
    return Cookies.get("refreshToken");
  },
  getUserRole() {
    return Cookies.get("userRole");
  }
}
